function HeaderBtns() {
    return (
        <div className="header_btn">
            <a href="https://www.pult.ru/news/novoe-pokolenie-akustiki-silver-ot-monitor-audio/" className="header_btn-link">
                Читать обзор
                <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M7 17L17 7" stroke="white" strokeLinecap="round" strokeLinejoin="round"/>
                <path d="M7 7H17V17" stroke="white" strokeLinecap="round" strokeLinejoin="round"/>
                </svg>
                </a>
            <a href="https://www.youtube.com/watch?v=GzdlxumDS2U" className="header_btn-link">
                видеообзор
                <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M5 3L19 12L5 21V3Z" stroke="white" strokeLinecap="round" strokeLinejoin="round"/>
                </svg>
                </a>
        </div>
    )
}
export default HeaderBtns;